import { useState } from "react";
import { Link } from "react-router-dom";
import { FOLIE } from "@/lib/pricing";

/** Interactive foil picker: swatch grid + details for the selected material. */
const FoilShowcase = () => {
  const [active, setActive] = useState(FOLIE[0].key);
  const foil = FOLIE.find((f) => f.key === active) || FOLIE[0];

  return (
    <section id="folie" className="py-12 md:py-20 bg-secondary/40">
      <div className="container mx-auto px-4">
        <div className="max-w-3xl mb-8 md:mb-12">
          <h2 className="text-2xl md:text-3xl lg:text-4xl font-bold text-foreground mb-3">
            Rodzaje folii do naklejek 3D – {FOLIE.length} materiałów
          </h2>
          <p className="text-muted-foreground leading-relaxed">
            Każdą naklejkę wypukłą zalewamy żywicą poliuretanową o wypukłości około 2 mm.
            Efekt końcowy zależy od folii – od klasycznej białej pod pełny kolor, przez chromy
            i maty, aż po folie holograficzne i odblaskowe. Kliknij materiał, aby poznać szczegóły.
          </p>
        </div>

        <div className="grid lg:grid-cols-[1.2fr_1fr] gap-6 lg:gap-10 items-start">
          <ul className="grid grid-cols-2 sm:grid-cols-3 gap-3">
            {FOLIE.map((f) => (
              <li key={f.key}>
                <button
                  type="button"
                  onClick={() => setActive(f.key)}
                  aria-pressed={active === f.key}
                  className={`w-full h-full text-left rounded-xl border p-3 transition-colors ${
                    active === f.key ? "border-accent bg-card shadow-md" : "border-border bg-card/60 hover:border-accent/60"
                  }`}
                >
                  <span
                    className="block w-full h-10 rounded-md mb-2 border"
                    style={{
                      background: f.gradient || (f.color === "transparent" ? "repeating-conic-gradient(#e5e7eb 0% 25%, #ffffff 0% 50%) 50% / 12px 12px" : f.color),
                      borderColor: f.border,
                    }}
                    aria-hidden="true"
                  />
                  <span className="block text-xs font-semibold text-foreground leading-snug">
                    {f.label.split(" + ")[0]}
                  </span>
                </button>
              </li>
            ))}
          </ul>

          <div className="rounded-2xl border border-border bg-card p-5 md:p-6 lg:sticky lg:top-24">
            <div
              className="w-full h-28 rounded-xl mb-4 border"
              style={{
                background: foil.gradient || (foil.color === "transparent" ? "repeating-conic-gradient(#e5e7eb 0% 25%, #ffffff 0% 50%) 50% / 16px 16px" : foil.color),
                borderColor: foil.border,
              }}
              aria-hidden="true"
            />
            <h3 className="text-lg font-bold text-foreground mb-2">{foil.label}</h3>
            <p className="text-sm text-muted-foreground leading-relaxed mb-3">{foil.desc}</p>
            {foil.hint && <p className="text-sm text-accent italic mb-3">{foil.hint}</p>}
            <Link
              to={`/kalkulator?folia=${foil.key}`}
              className="inline-flex items-center justify-center w-full gradient-gold text-accent-foreground font-semibold px-4 py-2.5 rounded-lg hover:opacity-90 transition-opacity"
            >
              Wyceń naklejki na tej folii
            </Link>
          </div>
        </div>
      </div>
    </section>
  );
};

export default FoilShowcase;
